import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectLinkedCardById } from '../../../../../selectors/paymentMethods';
import { MethodWrapperContainer } from '../MethodWrapper';
import { LinkedCard } from './LinkedCard';
import { IconFinanceBankCard24 } from '@cian/ui-kit';

interface IProps {
  id: string;
}

export const LinkedCardContainer = (props: IProps) => {
  const { id } = props;

  const { bankType, cardNumber, cardType } = useSelector(selectLinkedCardById(id));

  const bankIcon = bankType ? (
    <img src={require(`./assets/banks/${bankType}.png`)} width="24" height="24" />
  ) : (
    <IconFinanceBankCard24 />
  );
  const cardTypeIcon = cardType ? <img src={require(`./assets/cardTypes/${cardType}.svg`)} height="16" /> : null;

  return (
    <MethodWrapperContainer id={id}>
      <LinkedCard bank={bankIcon} cardType={cardTypeIcon} number={cardNumber} />
    </MethodWrapperContainer>
  );
};
